import { httpClient } from './httpClient';
import wareHouse from '../assets/svg/warehouse.svg';
import Shipped from '../assets/svg/shipped.svg';
import Received from '../assets/svg/received.svg';
import Installed from '@/assets/svg/noconnection.svg';
import Commissioned from '@/assets/svg/setting.svg';
import Connected from '@/assets/svg/wifi.svg';
import RMA from '@/assets/svg/ship.svg';
import Active from '@/assets/svg/tick.svg';
import tickIcon from '../assets/img/statusIcons/check.svg';
import Registered from '@/assets/svg/contract.svg';
import { getAllStatus } from '../enums/endpoints';
import Star from '../assets/svg/star.svg';
import NewOrdered from '../assets/svg/package.svg';
export const assignImage = (item: string) => {
  if (item === 'In-WareHouse') {
    return wareHouse;
  } else if (item === 'Shipped') {
    return Shipped;
  } else if (item === 'Received') {
    return Received;
  } else if (item === 'Installed') {
    return Installed;
  } else if (item === 'RMA') {
    return RMA;
  } else if (item === 'Commissioned') {
    return Commissioned;
  } else if (item === 'Active') {
    return Active;
  } else if (item === 'Connected') {
    return Connected;
  } else if (item === 'Ordered') {
    return NewOrdered;
  } else if (item === 'Registered') {
    return Registered;
  } else if (item === 'New') {
    return Star;
  } else {
    return '';
  }
};

export const getStatus = (
  setStatusList: React.Dispatch<any>,
  selected: string,
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>
) => {
  let updateStatusList: any = [];
  let statusLength = 0;

  httpClient
    .get(getAllStatus)
    .then((res: any) => {
      statusLength = Object.keys(res)?.length;

      for (const stat in res) {
        if (updateStatusList?.length < statusLength) {
          updateStatusList.push({
            name: res[stat],
            statusValue: parseInt(stat),
            imageIcon: assignImage(res[stat]),
            tickIcon: tickIcon,
          });
        }
      }
    })
    .catch((e: any) => {
      return [];
    });

  setStatusList(updateStatusList);
};
